import axios from 'axios';

// Configuración base de axios
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const STOCK_UPDATE_EVENT = 'stock:updated';

const STOCK_MUTATION_RULES = [
  { method: 'post', pattern: /^\/presupuestos\/[^/]+\/aceptar$/i },
  { method: 'post', pattern: /^\/pedidos\/[^/]+\/cancelar$/i },
  { method: 'post', pattern: /^\/productos$/i },
  { method: 'put', pattern: /^\/productos\/[^/]+$/i },
  { method: 'put', pattern: /^\/productos\/[^/]+\/stock$/i },
  { method: 'delete', pattern: /^\/productos\/[^/]+$/i }
];

const shouldNotifyStockUpdate = (config) => {
  const method = (config?.method || '').toLowerCase();
  const cleanUrl = (config?.url || '').split('?')[0];
  return STOCK_MUTATION_RULES.some(
    (rule) => rule.method === method && rule.pattern.test(cleanUrl)
  );
};

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Interceptor para agregar token automáticamente
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para manejar respuestas
api.interceptors.response.use(
  (response) => {
    if (typeof window !== 'undefined' && shouldNotifyStockUpdate(response.config)) {
      window.dispatchEvent(new CustomEvent(STOCK_UPDATE_EVENT));
    }
    return response.data; // Devolver solo los datos
  },
  
  (error) => {
    if (error.response?.status === 401) {
      // Token expirado o inválido
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/';
    }
    return Promise.reject(error.response?.data || error.message);
  }
);

export default api;